module.exports = __webpack_public_path__ + "static/media/bg.06728d63.svg";